import { useContext, useSyncExternalStore } from 'react'

import { TooltipContext, type TooltipState } from './context'

export function useTooltipState<T> (
  selector: (state: TooltipState) => T
) {
  const { store } = useContext(TooltipContext)
  const callback = () => selector(store.snapshot())

  return useSyncExternalStore(store.subscribe, callback, callback)
}
